/* eslint-disable no-nested-ternary */
import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface ISummaryTile {
  subTitle?: string;
  tileClass: string;
  tileCount: number;
  tileIcon: JSX.Element;
  title: string;
}

const TileWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
  flexGrow: 1,
}));

const TileContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1),
  textAlign: 'center',
  borderRadius: theme.shape.borderRadius,
}));

const TileIcon = styled(Box)(({ theme }) => ({
  fontSize: '2em',
  margin: theme.spacing(0.375),
  '& svg': {
    fill: 'white',
    fontSize: '1.2em',
    marginBottom: '-16px',
  },
}));

const TileTitle = styled(Typography)({
  fontSize: '1.1em',
  color: 'white',
});

const TileSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.4em',
  fontWeight: 'bold',
  color: theme.palette.common.white,
}));

export const SummaryTile = ({
  subTitle,
  tileClass,
  tileCount,
  tileIcon,
  title,
}: ISummaryTile) => (
  <TileWrapper
    sx={{
      width: {
        xs: '50%',
        sm: tileCount >= 5 ? '33.333%' : '50%',
        md: tileCount >= 7 ? '25%' : tileCount >= 5 ? '33.333%' : '50%',
      },
    }}
  >
    <TileContent className={`${tileClass}-bg`}>
      <TileIcon>{tileIcon}</TileIcon>
      <TileTitle variant="body1">{title}</TileTitle>
      <TileSubTitle variant="h6">{subTitle}</TileSubTitle>
    </TileContent>
  </TileWrapper>
);
